import * as signalR from '@microsoft/signalr';
import { __APIURLVIRTUALEXPO__ } from '../consts/consts';
import Storage from './Storage';
import { store } from '../store';
import { notificationReceived, liveFeedMessageReceived, receiveMessageFromServer, enterStand, leaveStand, certificateCreated } from '../redux/actions';
import messageSound from '../assets/messageSound.mp3';
import enterStandSound from '../assets/enterStand.mp3';
import notificationSound from '../assets/notificationSound.mp3';
import Utils from './Utils';
import { updateCalendar } from '../redux/actions/businessRounds.actions';

// Desbloqueo de audio: los navegadores bloquean Audio.play() hasta el primer
// gesto del usuario. Al primer click/tecla/touch "primamos" los sonidos (play
// muteado + pause) para que los avisos de chat/notificación suenen después.
if (typeof document !== 'undefined') {
  const primeAudio = () => {
    [messageSound, notificationSound, enterStandSound].forEach((src) => {
      try {
        const a = new Audio(src);
        a.volume = 0;
        const p = a.play();
        if (p && p.then) p.then(() => a.pause()).catch(() => {});
      } catch (e) { /* noop */ }
    });
    document.removeEventListener('click', primeAudio);
    document.removeEventListener('keydown', primeAudio);
    document.removeEventListener('touchstart', primeAudio);
  };
  document.addEventListener('click', primeAudio);
  document.addEventListener('keydown', primeAudio);
  document.addEventListener('touchstart', primeAudio);
}

class SignalrSocket {

    constructor() {
        this.signalRSocket = null;
        this.pageTitle = document.title;
        this.unfocusMessagesReceived = 0;
    }

    getSocket() {
        return this.signalRSocket;
    }

    create() {
        this.signalRSocket = new signalR.HubConnectionBuilder()
            .withUrl(__APIURLVIRTUALEXPO__ + 'chat', { accessTokenFactory: () => Storage.getJwtToken() })
            .withAutomaticReconnect([0, 2000, 5000, 5000, 5000, 5000, 10000, 10000, 10000, 30000, 30000, 30000, 30000, 30000, 30000, 30000, 30000, 30000, 30000, 30000, 30000, null])
            .configureLogging(signalR.LogLevel.Information)
            .withHubProtocol(new signalR.JsonHubProtocol())
            .build()
    }

    chatHandler = (payload) => {
        console.log('[BR-chat] mensaje recibido por socket:', payload);
        if (!payload) return;
        const { fromPersonId, toPersonId, message, messageGuid } = payload;
        const myId = Storage.getIdPerson();
        const isFromOther = fromPersonId != null && String(fromPersonId) !== String(myId);
        console.log('[BR-chat] de:', fromPersonId, '| yo:', myId, '| esDeOtro:', isFromOther);
        if (!isFromOther) {
            // Eco del propio mensaje: es el ACK del server (mensaje persistido +
            // broadcasteado al destinatario). No suma al badge, pero marca la
            // burbuja como entregada (✓) en el chat.
            console.log('[BR-chat] eco propio → ACK delivery del server (messageGuid:', messageGuid, ')');
            if (messageGuid) {
                store.dispatch({ type: 'MESSAGE_DELIVERED', payload: { messageGuid } });
            }
            return;
        }
        try {
            const audio = new Audio(messageSound);
            // play() puede ser bloqueado por la política de autoplay del navegador
            // hasta que el usuario interactúe; .catch evita el unhandled rejection.
            const p = audio.play();
            if (p && p.catch) p.catch((e) => console.log('[BR-chat] sonido bloqueado (autoplay):', e && e.message));
        } catch (e) { /* sin audio */ }

        store.dispatch(receiveMessageFromServer({
            fromPersonId,
            toPersonId,
            message,
            messageId: messageGuid,
        }));
        console.log('[BR-chat] dispatch receiveMessageFromServer → badge de no leídos actualizado');
    }
    standActionHandler = (fromIdPerson, personIdExhibitor, action) => {


        if (personIdExhibitor != Storage.getIdPerson()) {
            return;//Me llego el msj de otro expositor
        }
        let standEventInfo = {
            fromPersonId: fromIdPerson,
            fromPersonExhibitorId: personIdExhibitor
        }
        if (action == "enter") {
            let audio = new Audio(enterStandSound);
            audio.play();
            store.dispatch(enterStand(standEventInfo));
        }
        else {
            store.dispatch(leaveStand(standEventInfo));
        }

    }
    unsanitazed(str) {
        var ret = str.replace(/&gt;/g, '>');
        ret = ret.replace(/&lt;/g, '<');
        ret = ret.replace(/&quot;/g, '"');
        ret = ret.replace(/&apos;/g, "'");
        ret = ret.replace(/&amp;/g, '&');
        return ret;
    };
    notificationHandler = (notification) => {

        var newNotification = { ...notification, content: this.unsanitazed(notification.content), showToast: true }
        store.dispatch(notificationReceived(newNotification));
        let audio = new Audio(notificationSound);
        audio.play();
    }


    liveFeedHandler = (liveFeedMessage) => {

        store.dispatch(liveFeedMessageReceived(liveFeedMessage));
    }

    heartbeatHandler = () => {
        try {

            Utils.logOnConsole('Se recibió un heartbeat<=...');
            // verifico que el evento siga abierto
            if (Utils.isEventFinished() && Storage.getOverdueAccess() == false) {
                Utils.logOnConsole('Se desloguea porque no esta abierto el evento y no tiene permisos...');
                Utils.logOut();
            }
            let idRoom = Storage.getLiveStreamRoomId();
            let showingMiniVideoPlayer = false;
            if (Storage.getMiniPlayerSelectedRoomId() != null) {
                showingMiniVideoPlayer = true;
            }
            if (idRoom == null) {
                idRoom = Storage.getMiniPlayerSelectedRoomId();
            }
            // Si el socket no esta conectado (p.ej. reconectando por withAutomaticReconnect)
            // invoke() rechaza con "Cannot send data if the connection is not in the 'Connected' State."
            // No lo enviamos para no spamear reportes de error.
            if (!this.signalRSocket || this.signalRSocket.state !== signalR.HubConnectionState.Connected) {
                Utils.logOnConsole('No se envia heartbeat: socket no conectado (estado: ' + (this.signalRSocket ? this.signalRSocket.state : 'null') + ')');
                return;
            }
            this.signalRSocket.invoke('heartbeat', window.location.href + "||" + Number(idRoom) + "||" + showingMiniVideoPlayer)
                .then(() => Utils.logOnConsole('Se envió un heartbeat=>...'))
                .catch((ex) => {
                    console.error('Error enviando HEARTBEAT (invoke):', ex);
                    Utils.sendErrorToServer("Ocurrio un error enviando un HEARTBEAT (invoke)", "SignalrSocket", ex);
                });
        }
        catch (ex) {
            console.error('Error en heartbeatHandler:', ex);
            Utils.sendErrorToServer("Ocurrio un error enviando un HEARTBEAT", "SignalrSocket", ex);
        }
    }


    certificateCreatedHandler = (certificateUrl) => {

        store.dispatch(certificateCreated(certificateUrl));
    }

    refreshCalendar() {
        console.log("Refrescando calendario por pedido de websockets");
        store.dispatch(updateCalendar())
    }

    socketClosed() {
        console.log('socket cerrado!');
    }

    start() {
        this.signalRSocket.start().then(() => {

            console.log('socket abierto!');
            console.log('[BR-chat] socket conectado y escuchando evento "chat" (idPerson:', Storage.getIdPerson(), ')');
            // var heartBeat = this.signalRSocket.connection.heartBeatHub;
            // heartBeat.server.send('Heart beat listening');
        })
            .catch(err => {
                console.error(err, 'red');
                let error = "Obj err: " + JSON.stringify(err);
                error += "Hub Url: " + this.signalRSocket.connection.baseUrl;
                Utils.sendErrorToServer("Ocurrio un error abriendo en el start del socket", "SignalrSocket", error);
                // En modo embebido (librería) NO limpiamos storage ni redirigimos:
                // eso nukearía la sesión del host. Solo logueamos.
                if (!this.embedded) {
                    setTimeout(function () {
                        Storage.clearAll();//puede ser un tema con las cookies
                        window.location.href = "/";
                    }, 4000);
                }
                throw err;
            });
        this.signalRSocket.on('chat', this.chatHandler);
        this.signalRSocket.on('standAction', this.standActionHandler);
        this.signalRSocket.on('notification', this.notificationHandler);
        this.signalRSocket.on('liveFeed', this.liveFeedHandler);
        this.signalRSocket.on('certificateCreated', this.certificateCreatedHandler);
        this.signalRSocket.on('heartbeat', this.heartbeatHandler);
        this.signalRSocket.on('RefreshMeetings', this.refreshCalendar);
        this.signalRSocket.onclose(this.socketClosed());
        var me = this;
    }



}

export default SignalrSocket